// extracted by mini-css-extract-plugin
export default {"text":"css_text__oVMTz","buttonsRow":"css_buttonsRow__IKQbl","button":"css_button__ite0R"};